
import * as TasksActions from './actions';
import { createFeatureSelector, createSelector, createReducer, on, Action } from '@ngrx/store';
import { State, initializeTasksState } from './state';


export const initialState = initializeTasksState();

const reducer = createReducer(
  initialState,
  on(TasksActions.GetTasksAction, state => state),
  on(TasksActions.TasksLoadedAction, (state: State, { payload }) => {
    return {
      ...state,
      tasks: payload
    };
  }),
  on(TasksActions.BeginCreateTaskAction, state => {
      return {
        ...state,
        allowAddTask: false
      };
    }),
  on(TasksActions.SuccessCreateTaskAction, (state: State, { payload }) => {
    return {
      ...state,
      tasks: [payload, ...state.tasks],
      allowAddTask: true
    };
  }),
  on(TasksActions.BeginUpdateTaskAction, state => state),
  on(TasksActions.SuccessUpdateTaskAction, (state: State, { payload }) => {
    const tasks = state.tasks.map((task) => {
      if (task._id !== payload._id && task._id !== undefined) {
        return task;
      }
      return payload;
    });
    const selectedTask = state.selectedTask?._id === payload._id ? payload : state.selectedTask;
    return {
      ...state,
      tasks,
      selectedTask
    };
  }),
  on(TasksActions.SelectTaskAction, (state: State, { payload }) => {
    return {
      ...state,
      selectedTask: payload
    };
  }),
);

export function TaskReducer(state: State | undefined, action: Action) {
  return reducer(state, action);
}
